import React from 'react'
import ProductItem from '../../../../components/public/pages/home/productItem'
import { useState,useEffect } from 'react';
import { Link } from 'react-router-dom';
import ScreenSizes from '../../../../configTools/screenSizes';

const Newonkaay = ({Products}) => {
  const Columns = 96;
  const width = window.innerWidth;
  return (
    <div className='public_home_explore_b2c'>
        <div className='public_home_product_grid_1_container'>
        <div className='public_home_product_grid_1_title'>
            <div className='public_home_product_grid_1_title_details'>
                <h4>{'New on KAAY'}</h4>
                <p>{'For ecommerce of retailers'}</p>
            </div>
            <div className='public_home_product_grid_1_title_link'>
                <Link to={"/new-on-kaay"}>see more</Link>
            </div>
        </div>
        <div className='public_home_product_grid_1_products_wrapper_witharrow'>
            <div className='public_home_product_grid_1_products_wrapper'>
            <div className='public_home_product_grid_1_products'>
                {
                    Products.slice(0, parseInt(Columns)).map((product,index)=>{
                        return(
                            <div style={{width:String(((width > ScreenSizes.Mobile?320:832)/(parseInt(Columns)/3))-0.2)+"vw", marginTop:'0.2vw'}} key={index}>
                                <ProductItem Product={product} />
                            </div>
                        )
                    })
                }
            </div>
            </div>
        </div>
        </div>
    </div>
  )
}

export default Newonkaay
